'use client'

import { useAsset } from '@marketplace-web/shared/assets'

const useHowItWorksCardContent = () => {
  const asset = useAsset('/assets/landing-pages/dac7')

  const cardImage1Src = asset('IllustrationHowItWorks-1.png', {
    theme: { dark: 'IllustrationHowItWorks-1-dark.png' },
  })
  const cardImage1Src2x = asset('IllustrationHowItWorks-1@2x.png', {
    theme: { dark: 'IllustrationHowItWorks-1-dark@2x.png' },
  })
  const cardImage1Src3x = asset('IllustrationHowItWorks-1@3x.png', {
    theme: { dark: 'IllustrationHowItWorks-1-dark@3x.png' },
  })
  const cardImage1SrcSet = `${cardImage1Src} 1x, ${cardImage1Src2x} 2x, ${cardImage1Src3x} 3x`

  const cardImage2Src = asset('IllustrationHowItWorks-2.png', {
    theme: { dark: 'IllustrationHowItWorks-2-dark.png' },
  })
  const cardImage2Src2x = asset('IllustrationHowItWorks-2@2x.png', {
    theme: { dark: 'IllustrationHowItWorks-2-dark@2x.png' },
  })
  const cardImage2Src3x = asset('IllustrationHowItWorks-2@3x.png', {
    theme: { dark: 'IllustrationHowItWorks-2-dark@3x.png' },
  })
  const cardImage2SrcSet = `${cardImage2Src} 1x, ${cardImage2Src2x} 2x, ${cardImage2Src3x} 3x`

  const cardImage3Src = asset('IllustrationHowItWorks-3.png', {
    theme: { dark: 'IllustrationHowItWorks-3-dark.png' },
  })
  const cardImage3Src2x = asset('IllustrationHowItWorks-3@2x.png', {
    theme: { dark: 'IllustrationHowItWorks-3-dark@2x.png' },
  })
  const cardImage3Src3x = asset('IllustrationHowItWorks-3@3x.png', {
    theme: { dark: 'IllustrationHowItWorks-3-dark@3x.png' },
  })
  const cardImage3SrcSet = `${cardImage3Src} 1x, ${cardImage3Src2x} 2x, ${cardImage3Src3x} 3x`

  const cards = [
    {
      imageSrc: cardImage1Src,
      imageSrcSet: cardImage1SrcSet,
      title: 'item_1.title',
      description: 'item_1.description',
    },
    {
      imageSrc: cardImage2Src,
      imageSrcSet: cardImage2SrcSet,
      title: 'item_2.title',
      description: 'item_2.description',
    },
    {
      imageSrc: cardImage3Src,
      imageSrcSet: cardImage3SrcSet,
      title: 'item_3.title',
      description: 'item_3.description',
    },
  ]

  return cards
}

export default useHowItWorksCardContent
